export var primary = "#008000"
export var primaryLight = "#E4F5E7"
export var primaryDark = "#43C059"
export var contrastText = "#fff"
export var secondary = "#008000"
export var secondaryLight = "#E4F5E7"
export var secondaryDark = "#43C059"
export var inheritDefault1 = "#fefefe"
export var inheritDefault2 = "#f8f9ff"
export var second = "#070919"
export var indigo = "#7420ff"
export var purple = "#793de6"
export var pink = "#fc26a4"
export var red = "#f83245"
export var orange = "#f4772e"
export var yellow = "#ffc926"
export var green = "#1bc943"
export var teal = "#18e1a5"
export var cyan = "#27dcf3"
export default {"primary":"#008000","primaryLight":"#E4F5E7","primaryDark":"#43C059","contrastText":"#fff","secondary":"#008000","secondaryLight":"#E4F5E7","secondaryDark":"#43C059","inheritDefault1":"#fefefe","inheritDefault2":"#f8f9ff","second":"#070919","indigo":"#7420ff","purple":"#793de6","pink":"#fc26a4","red":"#f83245","orange":"#f4772e","yellow":"#ffc926","green":"#1bc943","teal":"#18e1a5","cyan":"#27dcf3"}
